module.exports = __webpack_public_path__ + "assets/img/vr_default.40b88a4b.png";